import { useState } from "react";
import { waLink, WHATSAPP_INTENTS } from "../config";

const CORPORATE_FORM_URL = "https://readdy.ai/api/form/d9vi7heth95mubjtu8d0";

export default function Corporate() {
  const [showForm, setShowForm] = useState(false);
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = ((fd.get("company_alt") as string) ?? "").trim();
    if (honeypot) {
      setStatus("success");
      form.reset();
      return;
    }
    fd.delete("company_alt");
    const body = new URLSearchParams(fd as never).toString();
    try {
      const res = await fetch(CORPORATE_FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body,
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = {};
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || responseText;
      if (res.ok && parsed?.code === "OK") {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setFormError(serverMsg || "Bir şeyler ters gitti. Lütfen tekrar deneyin.");
      }
    } catch {
      setStatus("error");
      setFormError("Ağ hatası. Lütfen tekrar deneyin.");
    }
  };

  return (
    <section id="kurumsal" className="bg-foreground-950 py-16 md:py-24 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          {/* Banner */}
          <div className="text-background-50">
            <span className="text-xs font-bold tracking-[0.25em] text-accent-400 uppercase">
              Kurumsal Yemek
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold leading-tight">
              EKİBİNİZE HER GÜN
              <br />
              SICAK EV YEMEĞİ.
            </h2>
            <p className="mt-5 text-background-50/70 leading-relaxed">
              Ofis, iş yeri ve ekipler için kurumsal yemek çözümlerimizi
              inceleyin.
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => setShowForm(true)}
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-bold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                KURUMSAL TEKLİF AL
                <i className="ri-arrow-right-line"></i>
              </button>
              <a
                href={waLink(WHATSAPP_INTENTS.corporate)}
                target="_blank"
                rel="nofollow noopener"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md border-2 border-accent-500 text-accent-400 text-base font-bold hover:bg-accent-500/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WHATSAPP'TAN BİLGİ AL
              </a>
            </div>
          </div>

          {/* Form */}
          <div className="bg-background-50 rounded-lg p-6 md:p-8">
            <h3 className="font-heading text-2xl font-bold text-foreground-950">
              Kurumsal Teklif Formu
            </h3>
            <p className="mt-2 text-sm text-foreground-500">
              Bilgilerinizi bırakın, satış ekibimiz size ulaşsın.
            </p>

            {!showForm && !status ? (
              <button
                onClick={() => setShowForm(true)}
                className="mt-6 w-full py-3.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-bold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                FORMU AÇ
              </button>
            ) : (
              <form
                data-readdy-form
                onSubmit={handleSubmit}
                className="mt-6 space-y-4"
              >
                <input
                  type="text"
                  name="company"
                  placeholder="Firma adı"
                  required
                  className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400"
                />
                <input
                  type="text"
                  name="contact_name"
                  placeholder="Yetkili adı"
                  required
                  className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400"
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Telefon"
                  required
                  className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400"
                />
                <input
                  type="text"
                  name="region"
                  placeholder="Bölge"
                  required
                  className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400"
                />
                <input
                  type="number"
                  name="daily_count"
                  placeholder="Günlük kişi sayısı"
                  min={1}
                  required
                  className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400"
                />
                <input
                  type="text"
                  name="company_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="lead-hp"
                />
                <button
                  type="submit"
                  className="w-full py-3.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-bold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  TEKLİF GÖNDER
                </button>
                {status === "success" && (
                  <p className="text-sm font-semibold text-primary-600 text-center">
                    Talebiniz alındı. Ekibimiz en kısa sürede size ulaşacak.
                  </p>
                )}
                {status === "error" && (
                  <p className="text-sm font-semibold text-primary-700 text-center">
                    {formError}
                  </p>
                )}
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}